// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 22H2V11H11V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H13V11H22V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.2334 2C12.7655 2.89763 12.5 3.91768 12.5 5C12.5 6.50876 13.0144 7.89709 13.877 9H2V2H13.2334Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.4551 3.54395L23.6797 5L20.4551 6.45508L19 9.67969L17.5439 6.45508L14.3203 5L17.5439 3.54395L19 0.320312L20.4551 3.54395Z"}}]};

const AiLayoutFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai-layout-filled',
    ref,
    icon: element,
  },
));

AiLayoutFilledIcon.displayName = 'AiLayoutFilledIcon';

export default AiLayoutFilledIcon;
